import { z } from 'zod'

const userRoleSchema = z.object({
  title: z.string(),
  useraccesslevel: z.number(),
})

const userStatusSchema = z.object({
  title: z.string(),
  activation: z.number(),
  clsColor: z.string(),
})

export interface IUserTable {
  items: IUserColumn[]
  total: number
  activatedTotal: number
  pendingTotal: number
  deactivatedTotal: number
}

export const userColumnSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  createdAt: z.string(),
  email: z.string(),
  search: z.string().optional(),
  status: userStatusSchema,
  lastestLogin: z.string().nullish(),
  role: userRoleSchema,
  invitationValid: z.boolean().nullable(),
})

export type IUserRole = z.infer<typeof userRoleSchema>
export type IUserStatus = z.infer<typeof userStatusSchema>
export type IUserColumn = z.infer<typeof userColumnSchema>
